import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InfraLiveSocketService {
  private socket: Socket;
  private readonly namespace = '/infralive';
  private readonly serverUrl = environment.socketCoreUrl;

  private connected$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  connect(): void {
    const proxyPath = this.serverUrl.startsWith('/')
      ? `${this.serverUrl}/socket.io`
      : '/socket.io';

    this.socket = io(`${this.serverUrl}${this.namespace}`, {
      path: proxyPath,
      transports: ['websocket'],
      reconnection: true,
    });

    this.socket.on('connect', () => {
      console.log('✅ Conectado ao InfraLive Gateway:', this.socket.id);
      this.connected$.next(true);
    });

    this.socket.on('disconnect', () => {
      console.warn('⚠️ Desconectado do InfraLive Gateway');
      this.connected$.next(false);
    });

    this.socket.on('infra_update', (data) => {
      // console.log('📩 Recebido update do InfraLive:', data);
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  joinRoom(room: string): void {
    if (this.socket && this.socket.connected) {
      this.socket.emit('join', { room });
    } else {
      this.connected$.subscribe((connected) => {
        if (connected) {
          this.socket.emit('join', { room });
        }
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  isConnected(): Observable<boolean> {
    return this.connected$.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  onInfraUpdate(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on('infra_update', (data) => subscriber.next(data));
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  disconnect(): void {
    if (this.socket) { this.socket.disconnect(); }
  }
}
